var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconBtn',{attrs:{"loading":_vm.loading,"icon":"mdi-folder-plus","title":"Monthly Items"},on:{"click":_vm.submit}})
}
var staticRenderFns = []

export { render, staticRenderFns }